module.exports = __webpack_public_path__ + "img/Avatar-3.3ffde867.png";